export default __webpack_public_path__ + "static/media/gallery_04.6ee7fe77.jpg";